import { Tooltip, Box } from '@chakra-ui/react'

type DotParams = {
  color?: string
  label?: string
  size?: number
}

export default function Dot({ color = 'primary.500', label, size = 10 }: DotParams) {
  return (
    <Tooltip bg={color} label={label}>
      <Box bg={color} rounded="full" height={`${size}px`} width={`${size}px`} />
    </Tooltip>
  )
}
